import * as React from 'react';
import Spinner from 'components/spinner/spinner.component';
import { IEventRequest } from 'modules/event-manager/event-manager.service';

interface IFetchEventProps {
    readonly eventFetchData: (request: IEventRequest) => void;
}

export class FetchEventComponent extends React.PureComponent<IFetchEventProps & IEventRequest, {}> {
    public componentDidMount() {
        const { country, code } = this.props;
        this.props.eventFetchData({ country, code });
    }

    public render() {
        return <Spinner />;
    }
}

export default FetchEventComponent;
